import React, { useCallback, useState } from 'react';
import { PageHeader } from '../components/shared/PageHeader';
import { Lightbox } from '../components/shared/Lightbox';
import { CtaBand } from '../components/shared/CtaBand';
import { galleryImages } from '../data/gallery';
import { images } from '../data/images';
export function Gallery() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const close = useCallback(() => setOpenIndex(null), []);
  const change = useCallback((index: number) => setOpenIndex(index), []);
  return <>
      <PageHeader crumb="Gallery" title="Gallery" subtitle="Inside our plant and a look at the products we make and supply." image={images.palletWrap} data-id="element-336" data-mp="2hmfu0zuwzdyl" />
      <section className="bg-ink py-16 md:py-24" data-id="element-337" data-mp="27r5qu8ss50j8">
        <div className="mx-auto max-w-[1320px] px-5 md:px-8" data-id="element-338" data-mp="23nps96x5gq3w">
          <ul className="grid gap-4 rounded-[32px] bg-flame p-4 sm:grid-cols-2 md:p-6 lg:grid-cols-3" data-id="element-339" data-mp="23q29tiyzwygf">
            {galleryImages.map((image, index) => <li key={image.src} data-id="element-340" data-mp="2k85fz0wt0nwa" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(index)} aria-label={`Open image: ${image.alt}`} className="group block w-full overflow-hidden rounded-[20px] bg-ink focus:outline-none focus-visible:ring-4 focus-visible:ring-ink" data-id="element-341" data-mp="2k7vota00wap0">
                  <img src={image.src} alt={image.alt} loading="lazy" className="aspect-[4/3] w-full object-cover transition-transform duration-300 ease-out-strong group-hover:scale-[1.04]" data-id="element-342" data-mp="32zxy20ac4op8" />
                </button>
              </li>)}
          </ul>
        </div>
      </section>
      <Lightbox images={galleryImages} index={openIndex} onClose={close} onChange={change} data-id="element-343" data-mp="1ijunu40k40ia" />
      <CtaBand data-id="element-344" data-mp="1im7auvl69127" />
    </>;
}